export const staticChannelTypeDescriptions = {
  'adbreak-rank-1':
    'An adbreak where 4/4 networks agree that the detected slot is a good place to insert an ad',
  'adbreak-rank-2':
    'An adbreak where 3/4 networks agree that the detected slot is a good place to insert an ad',
  'adbreak-rank-3':
    'An adbreak where 2/4 networks agree that the detected slot is a good place to insert an ad',
  'adbreak-rank-4':
    'Filler adbreaks to make sure there is at least one detected slot for every 5 minute of content',
  'preview-type-a': 'High-energy clips in feature films and intense content',
  'preview-type-b': 'High-energy clips in reality TV, documentaries or slower content',
  'preview-type-c': 'Sad or angry clips',
  'preview-type-d': 'Clips with positive emotions',
  'preview-type-e': 'Slower clips with focus on dialogues',
  'preview-type-q1': 'Clips with positive emotions but with lower tempo',
  'preview-type-q2': 'Clips with positive emotions but with higher tempo',
  'preview-type-q3': 'Moody clips',
  'preview-type-q4': 'Dark, intense and frightening clips',
}
